// Polyfill for browsers that don't support the Invoker Commands API (e.g. iOS Safari)
if (!('command' in document.createElement('button'))) {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[commandfor]');
    if (!button) return;

    const targetId = button.getAttribute('commandfor');
    const command = button.getAttribute('command');
    const target = document.getElementById(targetId);
    if (!target) return;

    if (command === 'show-modal' && target.tagName === 'DIALOG') {
      target.showModal();
    }
    else if (command === 'close') {
      if (target.tagName === 'DIALOG') target.close();
      else target.hidePopover?.();
    }
    else if (command === 'toggle-popover') {
      target.togglePopover?.();
    }
    else if (command === 'show-popover') {
      target.showPopover?.();
    }
    else if (command === 'hide-popover') {
      target.hidePopover?.();
    }
  });
}
class Dialog {
  constructor(dialog) {
    this.dialog = dialog;
    if (!this.dialog) return;

    this.dialog.addEventListener('toggle', (event) => {
      if (event.newState === 'open') {
        window.dispatchEvent(new CustomEvent('dialog:open', { detail: this.dialog,
          bubbles: true }));
      }
    });

    const form = this.dialog.querySelector('form');
    if (form) {
      form.addEventListener('submit', () => this.dialog.close());
    }
  }

  static prefetch(target) {
    const variantSelector = target.querySelector('variant-selector');
    if (!variantSelector || variantSelector._prefetchedHTML) return;

    const options = JSON.parse(variantSelector.dataset.options);
    const currentVariantId = variantSelector.closest('product-form-component')?.querySelector('input[name="id"]')?.value;
    const url = `${options.url}?variant=${currentVariantId}&section_id=theme-quick-shop`;
    variantSelector._prefetchedHTML = fetch(url).then(response => response.text());
  }

  static loadQuickShop(target) {
    const variantSelector = target.querySelector('variant-selector');
    return variantSelector?.handleVariantChange(null, true) ?? Promise.resolve();
  }
}

window.Dialog = Dialog;

window.initDialogs = function (container = document) {
  container = container ?? document;
  container.querySelectorAll('dialog:not([data-dialog-initialized])').forEach((dialog) => {
    dialog.setAttribute('data-dialog-initialized', '');
    new Dialog(dialog);
  });

  container.querySelectorAll('[data-dialog-quickshop-trigger]:not([data-dialog-trigger-initialized])').forEach((trigger) => {
    trigger.setAttribute('data-dialog-trigger-initialized', '');
    trigger.addEventListener('pointerenter', () => {
      const targetId = trigger.getAttribute('commandfor');
      const targetDialog = targetId ? document.getElementById(targetId) : null;
      if (targetDialog) Dialog.prefetch(targetDialog);
    }, { once: true });

    trigger.addEventListener('click', () => {
      const targetId = trigger.getAttribute('commandfor');
      const targetDialog = targetId ? document.getElementById(targetId) : null;
      if (!targetDialog) return;
      Dialog.loadQuickShop(targetDialog).then(() => {
        if (!targetDialog.open) targetDialog.showModal();
      });
    });
  });
};

window.initDialogs();

window.addEventListener('window:load-more', (event) => {
  initDialogs(event.detail.container);
});

window.addEventListener('shopify:section:load', (event) => {
  const sectionId = event.detail?.sectionId;
  if (!sectionId) return;
  const sectionEl = document.getElementById(`shopify-section-${sectionId}`);
  if (sectionEl) {
    initDialogs(sectionEl);
  }
});
